(function () {
  'use strict';

  var CART_API_RE = /\/cart(?:\/(?:add|change|update))?(\.js)?(?:\?|$)/;
  var pendingSync = null;

  function formatMoney(cents) {
    return (Number(cents) / 100).toFixed(2) + ' €';
  }

  function countEls() {
    return document.querySelectorAll('.announcement-cart .announcement-cart-count');
  }

  function priceEls() {
    return document.querySelectorAll('.announcement-cart > .cart-price, .announcement-cart #cart-total-price');
  }

  function applyCart(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;

    countEls().forEach(function (el) {
      el.textContent = String(cart.item_count);
    });

    priceEls().forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
      delete el.dataset.bgnPrice;
    });

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  function syncFromServer() {
    if (pendingSync) return pendingSync;

    pendingSync = fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js failed');
        return res.json();
      })
      .then(function (cart) {
        applyCart(cart);
        return cart;
      })
      .catch(function (e) {
        console.error('[DrStoykovCart]', e);
      })
      .finally(function () {
        pendingSync = null;
      });

    return pendingSync;
  }

  function bumpCount(delta) {
    if (!delta) return;
    countEls().forEach(function (el) {
      var current = parseInt(el.textContent, 10) || 0;
      el.textContent = String(current + delta);
    });
  }

  function patchFetch() {
    if (window.__dsCartFetchPatched) return;
    window.__dsCartFetchPatched = true;

    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCart = CART_API_RE.test(url);
      var isAdd = /\/cart\/add(\.js)?/.test(url);

      if (isAdd) {
        try {
          var body = init && init.body;
          if (typeof body === 'string') {
            var parsed = JSON.parse(body);
            if (parsed.items && parsed.items[0]) {
              bumpCount(parseInt(parsed.items[0].quantity, 10) || 1);
            }
          }
        } catch (e) {}
      }

      return nativeFetch(input, init).then(function (response) {
        if (isCart && response.ok) {
          response
            .clone()
            .json()
            .then(function (data) {
              if (data && typeof data.item_count === 'number') {
                applyCart(data);
              } else {
                syncFromServer();
              }
            })
            .catch(function () {
              syncFromServer();
            });
        }
        return response;
      });
    };
  }

  function bindEvents() {
    if (window.__dsCartEventsBound) return;
    window.__dsCartEventsBound = true;

    document.addEventListener('cart:add', function () {
      syncFromServer();
    });
    document.addEventListener('cart:change', function () {
      syncFromServer();
    });

    document.addEventListener('DOMContentLoaded', function () {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.cartData && typeof event.cartData.item_count === 'number') {
            applyCart(event.cartData);
          } else {
            syncFromServer();
          }
        });
      }
      syncFromServer();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') syncFromServer();
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) syncFromServer();
    });
  }

  patchFetch();
  bindEvents();

  window.DrStoykovCart = {
    applyCart: applyCart,
    syncFromServer: syncFromServer,
    bumpCount: bumpCount,
  };
})();
